export enum DictionaryKeyEnum {
    TASK_ORDER_TYPE = 'taskordertype',
    VEHICLE_CATEGORY = 'vehicle.category',
    ORDER_STATUS = 'orderstatus',
    DEPARTMENT = 'department',
    WASTECODES = 'wastecodes',
  }